(function () {
  'use strict';

  /* ---- Announcement bar rotation ---- */
  function initAnnounce() {
    var root = document.querySelector('[data-supra-announce]');
    if (!root) return;
    var slides = root.querySelectorAll('.supra-announce__slide');
    if (slides.length === 0) return;
    var i = 0;
    slides[0].classList.add('is-active');
    if (slides.length < 2) return;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4200);
  }

  /* ---- Sticky header shadow on scroll ---- */
  function initScrollShadow() {
    var header = document.querySelector('[data-supra-header]');
    if (!header) return;
    var lastY = 0;
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 12);
      lastY = y;
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Search overlay ---- */
  function initSearch() {
    var toggles = document.querySelectorAll('[data-supra-search-toggle]');
    var panel = document.querySelector('[data-supra-search]');
    if (!toggles.length || !panel) return;
    function open() {
      panel.hidden = false;
      setTimeout(function () {
        var input = panel.querySelector('input[name="q"]');
        if (input) input.focus();
      }, 50);
    }
    function close() { panel.hidden = true; }
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        panel.hidden ? open() : close();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  }

  /* ---- Mobile drawer ---- */
  function initDrawer() {
    var drawer = document.querySelector('[data-supra-drawer]');
    var openers = document.querySelectorAll('[data-supra-drawer-open]');
    var closers = document.querySelectorAll('[data-supra-drawer-close]');
    if (!drawer || !openers.length) return;

    function open() {
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      // Allow next frame for transition
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      var firstLink = drawer.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () { drawer.hidden = true; }, 320);
    }

    openers.forEach(function (o) { o.addEventListener('click', open); });
    closers.forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---- Cart count live update (fetch /cart.js on 'cart:updated' events) ---- */
  function initCartCount() {
    var el = document.querySelector('[data-supra-cart-count]');
    if (!el) return;
    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { var n = Math.max(0, parseInt(c.item_count, 10) || 0); el.textContent = n; el.setAttribute('data-supra-cart-count', n); })
        .catch(function () {});
    }
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('ajaxCart.afterCartLoad', refresh);
  }

  function boot() {
    initAnnounce();
    initScrollShadow();
    initSearch();
    initDrawer();
    initCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme-editor live reload
  document.addEventListener('shopify:section:load', boot);
})();
